import { useMemo } from 'react';
import { useTheme, useMediaQuery, Box } from '@mui/material';
import { 
  AirplanemodeActive,
  FlightTakeoff,
  Timelapse,
  FlightClass,
  AccessTime,
  AccessTimeFilled,  
} from "@mui/icons-material";
import ProgressBox from 'components/ProgressBox';


const IndicatorsCard = ({ data }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
 
  const stats = useMemo(() => [
    {
      icon: <AirplanemodeActive sx={{ color: "green.dark", fontSize: 24 }} />,      
      props: {
        "Aircraft": data.aircraftCount?.toLocaleString('en-US'),
        "BH/ AC/ Day": data.bh1AC1Day?.toFixed(1),
      }    
    },
    {
      icon: <FlightTakeoff sx={{ color: "green.dark", fontSize: 24 }} />,
      props: {
        title: "Flights",
        divisor: data.flownFlightsCount?.toLocaleString('en-US'),
        dividend: data.flightsTotal?.toLocaleString('en-US'),
        progress: data.flightsTotal && (data.flownFlightsCount / data.flightsTotal * 100),
        rate: `${(data.flightsTotal && (data.flownFlightsCount / data.flightsTotal * 100).toFixed(0)) || 0}%`,
      }
    },
    {
      icon: <Timelapse sx={{ color: "green.dark", fontSize: 24 }} />,
      props: {
        title: "Block Hours",
        divisor: Number(data.flownBlockTime?.toFixed(0)).toLocaleString('en-US'),
        dividend: Number(data.blockTime?.toFixed(0)).toLocaleString('en-US'),
        progress: data.blockTime && (data.flownBlockTime / data.blockTime * 100),
        rate: `${(data.blockTime && (data.flownBlockTime / data.blockTime * 100)?.toFixed(0)) || 0}%`,
      }
    },
    {
      icon: <FlightClass sx={{ color: "green.dark", fontSize: 24 }} />,
      props: {
        title: "Load Factor",
        divisor: `${(data.noOfPax / 1000)?.toFixed(0)}K`,
        dividend: data.capacity?.toLocaleString('en-US'),
        progress: data.loadFactor * 100,
        rate: `${(data.loadFactor * 100 || 0)?.toFixed(1)}%`,
      }
    },
    {
      icon: <AccessTime sx={{ color: "green.dark", fontSize: 24 }} />,
      props: {
        title: "Dep OTP",
        divisor: data.depOntimeCount?.toLocaleString('en-US'),
        dividend: data.flownFlightsCount?.toLocaleString('en-US'),
        progress: data.depOTP,
        rate: `${data.depOTP?.toFixed(1)}%`,
      }
    },
    {
      icon: <AccessTimeFilled sx={{ color: "green.dark", fontSize: 24 }} />,
      props: {
        title: "Arr OTP",
        divisor: data.arrOntimeCount?.toLocaleString('en-US'),
        dividend: data.arrivedFlightsCount?.toLocaleString('en-US'),
        progress: data.arrOTP,
        rate: `${data.arrOTP?.toFixed(1)}%`,
      }
    },
  ], [data]);


  return (
    <Box      
      id="indicators"
      component="section"
      display="grid"
      gridTemplateColumns="repeat(12, minmax(0, 1fr))"
      gridAutoRows={100}
      gap={2}           
      p={0.5}
      sx={{ "& > div": { gridColumn: isDesktop ? "span 2" : isTablet ? "span 4" : isMobile ? "span 6" : "span 4" } }}
    >       
      {stats.map((item, index) => (
        <ProgressBox
          key={index}
          icon={item.icon}
          props={item.props}          
        />
      ))}            
    </Box>    
  );
}

export default IndicatorsCard;